export enum Dictionary {
  CALLER_TEMPLATE_SUITES = 'CALLER_TEMPLATE_SUITES',
  DM_ZONES = 'DM_ZONES',
  DM_HARDWARE_TYPES = 'DM_HARDWARE_TYPES',
  RABBIT_ENDPOINTS = 'RABBIT_ENDPOINTS',
  RABBIT_MESSAGE_TYPES = 'RABBIT_MESSAGE_TYPES',
  UM_USERS = 'UM_USERS',
}
